<template>
  <tg-layout :headerHeight="headerHeight">
    <template slot="header">
      <tg-search-tool @on-submit="handleSearch">
        <tg-date-search
          ref="dateSearch"
          size="small"
          v-model="dateRange"
          showDateRangePicker
          twoMonthLimit
          isAccountDate
        ></tg-date-search>
      </tg-search-tool>
      <el-row style="padding:5px;">
        <!-- 平台選擇按鈕 -->
        <third-party-search-btn
            style="display:initial;"
            @click.native="showThirdPartyCheckBoxDialog"
        ></third-party-search-btn>
        <third-party-platform
          v-model="third_party"
          @on-change="handleSearchThirdParty"
        ></third-party-platform>
      </el-row>
      <tg-amount-bar ref="amount" v-if="showAmount" :columns="currentAmountColumns" :row="amountData"></tg-amount-bar>
      <span class="fs-sm">{{$t('note.twoMonthOnly')}}</span>
    </template>
    <tg-table
      ref="table"
      :columns="currentColumns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      @on-loaded="handleLoaded"
      :summary-method="parsePageSummary"
      showSummary
    >
      <template slot="betId" slot-scope="scope">
        <tg-bet-id :row="scope.row"></tg-bet-id>
      </template>

      <template slot="source_type" slot-scope="scope">
        <span :class="['text-' +  scope.row.source_type]">
            {{ $t("component.label.source_type." + scope.row.source_type) }}
        </span>
      </template>

      <template slot="betContent" slot-scope="scope">
        <tg-bet-content v-if="scope.row.source_type == 'tg'" :row="scope.row"></tg-bet-content>
        <third-party-saba-bet-content v-else-if="
            ((scope.row.source_type == 'saba' || scope.row.source_type == 'sabawhite_sport') &&
            (scope.row.content_type == 2 || scope.row.content_type == 5))
            || (scope.row.source_type.includes('sport') && scope.row.serial_type == 1) //serial_type == 1 非串關
          "
           :row="scope.row"></third-party-saba-bet-content>
        <third-party-saba-parlay-bet-content v-else-if="(scope.row.source_type == 'saba' || scope.row.source_type == 'sabawhite_sport') && (scope.row.content_type == 3 || scope.row.content_type == 4)" :row="scope.row" @on-click="handlePublicParlayDialog(scope.row)"></third-party-saba-parlay-bet-content>
        <third-party-saba-parlay-bet-content
          v-else-if="
            (scope.row.source_type != 'saba' && scope.row.source_type.includes('sport')) 
          "
          :row="scope.row"
          @on-click="handlePublicParlayDialog(scope.row)"
        ></third-party-saba-parlay-bet-content>
        <third-party-public-bet-content
          v-else
          :row="scope.row"
        ></third-party-public-bet-content>
      </template>

      <template slot="decimal" slot-scope="scope">
        <tg-decimal v-bind="scope"></tg-decimal>
      </template>
    </tg-table>

    <!-- 沙巴串關詳情 -->
    <third-party-saba-detail-dialog
      ref="sabaParlayMatchs"
    ></third-party-saba-detail-dialog>
    <!-- 沙巴串關結果 -->
    <third-party-saba-result-dialog
      ref="sabaParlayResult"
    ></third-party-saba-result-dialog>

    <!-- 平台篩選彈窗 -->
    <third-party-check-box-dialog
      ref="thirdPartyCheckBoxDialog"
      :third_party="third_party"
      @on-click="handleSearchThirdParty"
    ></third-party-check-box-dialog>

  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgTable from "@/components/table/TgTable";
import TgBetContent from "@/components/slot/TgBetContent";
import TgDecimal from "@/components/slot/TgDecimal";
import TgAmountBar from "@/components/amount/TgAmountBar";
import ThirdPartySabaBetContent from "@/components/slot/ThirdPartySabaBetContent";
import ThirdPartySabaParlayBetContent from "@/components/slot/ThirdPartySabaParlayBetContent";
import ThirdPartySabaDetailDialog from "@/components/dialog/ThirdPartySabaDetailDialog";
import ThirdPartySabaResultDialog from "@/components/dialog/ThirdPartySabaResultDialog";
import ThirdPartyPublicBetContent from "@/components/slot/ThirdPartyPublicBetContent";
import TgBetId from "@/components/slot/TgBetId";
import ThirdPartyCheckBoxDialog from "@/components/dialog/ThirdPartyCheckBoxDialog";
import ThirdPartySearchBtn from "@/components/button/ThirdPartySearchBtn";
import ThirdPartyPlatform from '@/components/tool/ThirdPartyPlatform';

import { summary } from "@/utils/table";
import {sabaParlayHandler} from "@/mixins/betContent";
import {thirdPartyCheckBoxDialogHandler} from "@/mixins/third_party/dialog";
import apis from "@/apis";

const api = apis.accounts.income.detail;

export default {
  components: {
    TgLayout,
    TgSearchTool,
    TgDateSearch,
    TgTable,
    TgBetContent,
    TgDecimal,
    TgAmountBar,
    ThirdPartySabaBetContent,
    ThirdPartySabaParlayBetContent,
    ThirdPartySabaDetailDialog,
    ThirdPartySabaResultDialog,
    ThirdPartyPublicBetContent,
    TgBetId,
    ThirdPartyCheckBoxDialog,
    ThirdPartySearchBtn,
    ThirdPartyPlatform
  },
  
  mixins: [sabaParlayHandler,thirdPartyCheckBoxDialogHandler],
  data() {
    return {
      dateRange: {
        startDate: "",
        endDate: ""
      },
      columns: [],
      amountColumns: [],
      amountData: {},
      showAmount: false,
      proxy: api.getData,
      searchData: {
        third_party:[],
      },
      third_party:[],
      amountPageData: {},
      init: false
    };
  },
  created() {
    if (this.$route.params && this.$route.params.entry != undefined){
      this.third_party = [this.$route.params.entry];
      this.searchData.third_party = this.third_party.map(r => {
        return r.platform;
      });
    }

    let dateRange = this.$route.params;
    if (!dateRange.startDate) {
      this.$router.push({ name: "accounts.income" });
      return;
    }

    this.$route.meta.title = this.$t("component.label.detail");

    api.getColumns().then((response) => {
      this.columns = response.data.columns;
      this.amountColumns = response.data.amountColumns;
      // this.currentColumns = response.data.columns.filter(c => !c.third_party || this.searchData.third_party.findIndex(x => c.third_party == x) > -1);
      
      this.$nextTick(() => {
        this.$refs.table.init({...this.request, ...dateRange});
        this.dateRange = {startDate: dateRange.startDate, endDate: dateRange.endDate};
        this.init = true;
      });
    });
  },
  props: {
    startDate: String,
    endDate: String,
    entry: Object
  },
  computed: {
    request() {
      return { ...this.searchData, ...this.dateRange };
    },
    headerHeight() {
      return !this.showAmount ? 120 : 200;
    },
    currentColumns() {
      return this.columns.filter(c => !c.third_party || this.searchData.third_party.findIndex(x => c.third_party == x) > -1)
    },
    currentAmountColumns() {
      return this.amountColumns.filter(c => !c.third_party || this.searchData.third_party.findIndex(x => c.third_party == x) > -1);
    }
  },
  methods: {
    handleSearch() {
      console.log('handleSearch', this.request);
      this.$refs.table.search(this.request);
    },
    handleLoaded(response) {
      this.showAmount = response.amount_data && response.data.length > 0;
      this.amountPageData = response.amountPageData;
      this.amountData = response.amount_data;
      // let columns = JSON.parse(JSON.stringify(this.columns));
      // this.currentColumns = columns.filter(c => !c.third_party || this.searchData.third_party.findIndex(x => c.third_party == x) > -1);
    },
    handleSearchThirdParty(value) {
      this.third_party = value;
      this.searchData.third_party = this.third_party.map(r => {
        return r.platform;
      });
      this.$nextTick(() => {
        if (this.init) {
          this.$refs.table.search(this.request);
        }
      });
    },
    parsePageSummary() {
      let data = this.amountPageData ? [this.amountPageData] : [];

      return summary(
        this.currentColumns,
        data,
        this.$t("component.table.summary"),
        5
      );
    },
  },
  watch: {
    startDate(val) {
      this.dateRange.startDate = val;
    },
    endDate(val) {
      this.dateRange.endDate = val;
    },
    entry(val) {
      if (val) {
        this.third_party = val;
        this.searchData.third_party = this.third_party.map(r => {
          return r.platform;
        });
      }
    }
  },
};
</script>